import vi from '../JsonLang/vi.json'
export const lang = { ...vi }